export default {
  ja:[
    "決定したアイデア",
    "提案者",
    "値段",
    "Stripe 手数料(3.6%) 円",
    "状態",
    "新品",
    "中古",
    "購入"
  ],
  en: [
    "Your dicided idea",
    "Proposer",
    "Price",
    "Stripe fee(3.6%) JPY",
    "State",
    "New",
    "Used",
    "Purchase"
  ]
}
